export interface TrustpilotReview {
  customerName: string;
  rating: 1 | 2 | 3 | 4 | 5;
  comment: string;
  verified: boolean;
  date: string;
}

export const trustpilotReviews: TrustpilotReview[] = [
  {
    customerName: "Zela Zhang",
    rating: 5,
    comment: "We had a great experience with Gaia Powered. Alex helped us choose the right air source heat pump and guided us through the installation process. He is extremely professional, knowledgeable, and also a very nice person to work with.",
    verified: true,
    date: "December 2024"
  },
  {
    customerName: "Anna Salles",
    rating: 5,
    comment: "Gaia were fantastic from start to finish. Gary was so helpful and answered all our questions. The install team were also so friendly and tidy",
    verified: true,
    date: "March 2026"
  },
  {
    customerName: "Mike",
    rating: 5,
    comment: "Had a few quotes for my new heat pump and decided to use Gaia Powered because of the way they explained everything to me and the transparency of pricing. They’ve done a great job",
    verified: true,
    date: "January 2025"
  },
  {
    customerName: "Anthony Goodings",
    rating: 5,
    comment: "Gaia were one of 4 quotes we received for a new heat pump. They were great and managed to complete the installation in only 3 days. I chose Gaia because of the way they simplified all the technical jargon.",
    verified: true,
    date: "March 2026"
  },
  {
    customerName: "bradley oliver",
    rating: 5,
    comment: "We recently had an air source heat pump and new radiators installed, and the service from Gaia was excellent from start to finish. They were incredibly clear and transparent throughout the whole process, which made everything feel straightforward and stress-free. The team were professional, knowledgeable, and always happy to answer any questions we had. The installation was carried out efficiently and to a high standard, and everything was explained clearly along the way. We're really pleased with the end result and would highly recommend Gaia to anyone considering a heat pump installation.",
    verified: true,
    date: "March 2026"
  },
  {
    customerName: "Nick Skinner",
    rating: 5,
    comment: "Had a new heat pump installed by Gaia Powered and everything was so easy. From quote to design to installation everything was made simple",
    verified: true,
    date: "January 2025"
  },
  {
    customerName: "Dale Burton",
    rating: 5,
    comment: "The Gaia team made everything so simple. The initial survey and report were very thorough, they took the time to explain all the options to me clearly without any pushy sales tactics. Gave really good honest advice that gave me confidence in my decision.",
    verified: true,
    date: "February 2025"
  },
  {
    customerName: "Deniz",
    rating: 5,
    comment: "I had my solar panels installed first and then decided to get the ASHP to heat my home with all the electric I was generating. I'm amazed at how well it all works",
    verified: true,
    date: "January 2026"
  },
  {
    customerName: "Kane Khakbazan",
    rating: 5,
    comment: "Very happy with my new heat pump. Only took the guys 3 days to install it.",
    verified: true,
    date: "May 2025"
  },
  {
    customerName: "Dan O’connor",
    rating: 5,
    comment: "Thank you to everyone at Gaia Powered especially Robbie and Neil who took great care of our home",
    verified: true,
    date: "May 2025"
  },
  {
    customerName: "Eleanor ODea",
    rating: 5,
    comment: "I did a lot of research before deciding on what company to chose for my solar panels. A friend recommended Gary and his team. The entire processes was very quick and efficient. Robbie and the team were very tidy and I am very pleased with the work done.",
    verified: true,
    date: "September 2025"
  }
]
